module.exports = __webpack_public_path__ + "static/media/leader.ad55a0de.png";